module.exports = __webpack_public_path__ + "img/03.bfa962e9.png";